import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React from 'react';

import trash from '../../../assets/trash.png';
import { IDispute } from '../../../utils/types';
import { useGetDisputeReasonsQuery } from '../disputeSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

type formDisputeProps = {
    dispute: IDispute | null;
    index: number;
    handleFormChange: (event: any, index: number) => void;
    removeDispute: (index: number) => void;
};

export const AddFormDispute = ({ dispute, index, handleFormChange, removeDispute }: formDisputeProps) => {
    const { data: disputeReasonData } = useGetDisputeReasonsQuery({
        typeId: 1,
    });

    return (
        <>
            <Divider className="m-0 pb-4" />
            <div className="col-md-11 pe-0" style={{ width: '95.6%' }}>
                <Button
                    className="p-button text-center w-100 borderRadius"
                    style={{ backgroundColor: `${dispute?.metricHeaderColor}` }}
                    label={`Dispute - ${index + 1}`}
                />
                <div className="row pt-3" key={index}>
                    <div className="col-md-6 pt-1">
                        <div className="row">
                            <div className="col-md-6">
                                <h6>Metric</h6>
                                <InputText
                                    name="metricLabels"
                                    value={dispute?.metricLabel}
                                    disabled
                                    onChange={(event) => handleFormChange(event, index)}
                                    className="borderRadius"
                                />

                                <h6 className="mt-3 pt-2">Dispute Reason</h6>
                                <Dropdown
                                    name="disputeReasonid"
                                    value={dispute?.disputeReasonid}
                                    options={disputeReasonData?.data}
                                    onChange={(event) => handleFormChange(event, index)}
                                    optionValue={'reason_id'}
                                    optionLabel={'reason_name'}
                                    placeholder="Select Reason"
                                    className={`borderRadius ${
                                        dispute?.disputeReasonid === 0 ? 'p-invalid' : ''
                                    }`}
                                />
                            </div>
                            <div className="col-md-6">
                                <h6>Disputed Value</h6>
                                <InputText
                                    name="disputedValue"
                                    disabled
                                    value={dispute?.disputedValue}
                                    onChange={(event) => handleFormChange(event, index)}
                                    className="borderRadius"
                                />

                                <h6 className="mt-3 pt-2">Expected Value</h6>
                                <InputText
                                    name="proposedValue"
                                    value={dispute?.proposedValue === 0 ? '' : dispute?.proposedValue}
                                    keyfilter={/^([/.0-9]|[/.0-9]?%)$/}
                                    onChange={(event) => handleFormChange(event, index)}
                                    className="borderRadius"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <DescriptionBox
                            title="Associate Comment"
                            value={dispute?.disputeComment}
                            responseDescription={dispute?.disputeComment}
                            limit={4000}
                            className={`borderRadius ${dispute?.disputeComment === '' ? 'p-invalid' : ''}`}
                            onChange={(value) => {
                                const syntheticEvent = {
                                    target: {
                                        name: 'disputeComment',
                                        value,
                                    },
                                };
                                handleFormChange(syntheticEvent, index);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-1 p-0 text-end" style={{ width: '4.4%' }}>
                <img
                    src={trash}
                    id="gg"
                    onClick={() => removeDispute(index)}
                    onKeyDown={() => removeDispute(index)}
                    alt="Delete dispute"
                    role="presentation"
                />
            </div>
        </>
    );
};
